import { Accordion, Button, Stack } from 'react-bootstrap';
import { AnnouncementType, IAnnouncementModel } from '../../interfaces/IAnnoucementModel';

import { AnnouncementAccordion } from './AnnouncementAccordion';
import Authorization from '../../stores/Authorization';
import { IconButton } from '../../shared/buttons/IconButton';
import { Loader } from '../../components/shared/Loader';
import { PageWithAffixedHeader } from '../../shared/PageWithAffixedHeader';
import { useAuthContext } from '../../contexts/AuthContext';
import { useGetAnnouncements } from './useGetAnnouncements';
import { useState } from 'react';

export function Announcements() {
    const { isLoggedIn } = useAuthContext();
    const { user } = useAuthContext();

    const announcementsQuery = useGetAnnouncements(isLoggedIn);
    const [activeKeys, setActiveKeys] = useState<string[]>([]);
    if (announcementsQuery.isLoading) {
        return <Loader />;
    }

    const viewAbleAnnouncements = announcementsQuery?.data?.filter((announcement) => {
        if (announcement.announcementTypeId === AnnouncementType.Page) {
            const zoneGuids: string[] =
                user?.organizationRoles?.map((orgRole) => orgRole.guid ?? '') || [];

            const isAuthorizedForAnyZone = zoneGuids.some((zoneGuid) =>
                Authorization.isAuthorizedToRoute(announcement.routeKey, user, zoneGuid)
            );

            return isAuthorizedForAnyZone;
        }

        return true;
    });

    const atleastOneExpanded = activeKeys.length > 0;

    const handleExpandCollapseAll = () => {
        atleastOneExpanded ? handleCollapseAll() : handleExpandAll();
    };

    const handleExpandAll = () => {
        setActiveKeys(
            viewAbleAnnouncements?.map((viewAbleAnnouncement) => viewAbleAnnouncement.guid) ?? []
        );
    };

    const handleCollapseAll = () => {
        setActiveKeys([]);
    };
    return (
        <>
            <PageWithAffixedHeader headerComponent={<h1>Announcements</h1>}>
                <Stack gap={2} direction="horizontal" style={{ paddingBottom: '15px' }}>
                    <IconButton
                        buttonCssClass="btn btn-black"
                        icon={`fal ${atleastOneExpanded ?"fal fa-minus" : "fa fa-plus"}`}
                        onClick={handleExpandCollapseAll}
                        text={atleastOneExpanded ? "Collapse All" : "Expand All"}
                    />
                </Stack>
                <Accordion activeKey={activeKeys}>
                    <Stack gap={2}>
                        {viewAbleAnnouncements?.map((announcement: IAnnouncementModel) => {
                            return (
                                <div key={announcement.guid}>
                                    <AnnouncementAccordion
                                        announcement={announcement}
                                        activeKeys={activeKeys}
                                        setActiveKeys={setActiveKeys}
                                    />
                                </div>
                            );
                        })}
                    </Stack>
                </Accordion>
            </PageWithAffixedHeader>
        </>
    );
}
